/*  https://developer.mozilla.org/en-US/docs/Learn/HTML/Forms/Sending_forms_through_JavaScript#Dealing_with_binary_data
*/
import Axios from 'axios/dist/axios.min.js';
import {getTokenData} from './request';
import config from '../config';

export const uploadForm = async (url, formData, includePortal = true) => {
  const token = await getTokenData();
  const uri = `${config.apiUrl}v1.0${
    includePortal ? `/portal/${token.tokenData.portal_id}` : ''
  }${url}`;

  const headers = {};
  if (token.access_token) {
    headers.Authorization = `${token.token_type} ${token.access_token}`;
  }

  try {
    const response = await Axios.post(uri, formData, {
      headers,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return {
      error:
        (error.response && error.response.data) || error,
    };
  }
};

export function uploadFile(url, file, includePortal = true) {
  const data = new FormData();
  data.append('file', file);
  data.append('fileName', file.name);
  return uploadForm(url, data, includePortal);
}



// WEBPACK FOOTER //
// ./src/api/file-upload.js